/** ボトムメニュー直上（BottomNav が :root に書く実測高さ） */
export const MOBILE_SHEET_BOTTOM_OFFSET = 'var(--kotomil-bottom-nav-height, 6rem)';

/**
 * ボトムシートの Z 順。sticky ヘッダ（例: 分析 z-30）配下。ナビは z-[100]。
 * シートをナビより上にしないこと（全面レイヤーでナビが隠れる）。
 */
export const MOBILE_ANALYSIS_SHEET_STACKING = 'z-[9]';
